module.exports = __webpack_public_path__ + "static/media/facebook-logo-button.563ff79c.svg";